import { LightTooltip } from "@Components/generic";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface ICounterBar {
  count: number;
  total: number;
  styles?: any;
  size?: number;
  spacing: number;
  disableTooltip?: boolean;
}

const CounterBar = ({ count = 0, total = 10, styles = {}, size = 32, spacing = 0, disableTooltip = false }: ICounterBar) => {
  const theme = useTheme();
  let totalArray = [];
  for (let i = 0; i < total; i++) {
    totalArray.push(i);
  }

  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
        display: "inline-flex",
        backgroundColor: "#1A181D",
        paddingLeft: theme.spacing(1.2),
        paddingRight: theme.spacing(1.5),
        boxSizing: "border-box",
        height: `${size}px`,
        clipPath: `polygon(${size - 2}px 0, 100% 0, calc(100% - ${size - 2}px) 100%, 0% 100%)`,
        ...styles.container,
        marginBottom: `${size}px`,
      }}
    >
      {totalArray.map((value, index) => {
        const current = index + 1 === count;
        return (
          <Box
            key={index}
            sx={{
              transform: `skew(-45deg)`,
              height: "100%",
              boxSizing: "border-box",
              marginRight: `${spacing}px`,
              width: "30px",
              opacity: 0.8,
              ...(index < count
                ? current
                  ? {
                      background: theme.palette.dsPrimary.v200,
                      borderLeft: `1px solid ${theme.palette.dsSurface.v300}`,
                      borderTop: `1px solid ${theme.palette.dsSurface.v300}`,
                      borderBottom: `1px solid ${theme.palette.dsSurface.v300}`,
                      borderRight: `1px solid ${theme.palette.dsSurface.v300}`,
                    }
                  : {
                      background: theme.palette.dsPrimary.v300,
                      borderLeft: "4px solid transparent",
                    }
                : {
                  background: theme.palette.dsSurface.v300,
                  borderLeft: "4px solid transparent",
                }),
            }}
          />
        );
      })}
      {!disableTooltip ? (
        <LightTooltip title={`Completed ${((count / total) * 100).toFixed(0)}%`} enterDelay={300} leaveDelay={50}>
          <Box
            sx={{
              position: "absolute",
              marginRight: theme.spacing(1),
              marginTop: theme.spacing(0),
              marginBottom: theme.spacing(1),
              padding: theme.spacing(1),
              background: "transparent",
              width: "100%",
              textAlign: "center",
            }}
          />
        </LightTooltip>
      ) : null}
    </Box>
  );
};

export default CounterBar;
